import { useContext, useState } from 'react';
import './login.css';
import { auth } from '../config/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useCookies } from 'react-cookie';

export default function Login(){

    // const {login} = useContext(AuthContext)

    const [user, setUser] = useState()
    const [pass, setPass] = useState()
    const [showPass, setShowPass] = useState(false)

    const [cookies, setCookie, removeCookie] = useCookies(['auth']);

    const loginSubmit = async(e)=>{
        e.preventDefault()
        try{
            const userdetails = await signInWithEmailAndPassword(auth, user, pass);
            if(userdetails){
                setCookie('auth', true, { path: '/admin' });
            }         
        }catch(err){
            alert("Wrong Credential")
        }

    }

    const [forget, setForget] = useState(false);
    const [reset, setReset] = useState(null)

    const forgetPass = () =>{
        return(
            <div className='forgetScreen glassMorph'>
                <div className='loginContainer forgetConatainer'>
                    <h3 onClick={()=>{setReset(null);setForget(!forget)}}>X</h3>
                    <form onSubmit={async(e)=>{
                        e.preventDefault()
                        try {
                            await sendPasswordResetEmail(auth, reset);
                            alert("Password reset email sent");
                            setForget(!forget)
                            setReset(null)
                        } catch (err) {
                            console.log(err.message);
                        }
                        
                    }}>
                    {/* <form onSubmit={resetSubmit}> */}
                        <h1>Reset Password</h1>
                        <div className='inputField'>
                            <input
                                className='inputStyle'
                                type='email'
                                placeholder='Email'
                                value={reset}
                                onChange={(e)=>setReset(e.target.value)}
                                required
                            />
                        </div>
                        <div className='submitLogin'>
                            <input
                                className='btn btnBlue'
                                type='submit'
                                value="Submit"
                            />
                        </div>
                    </form>
                </div>
            </div>
        )
    }

    return(
        <div className='wrapper admin'>
            <div className='loginScreen'>                
                <div className='loginContainer'>
                    <form onSubmit={loginSubmit}>
                        <h1>Aurum Gold</h1>
                        <div className='inputField'>
                            <input
                                className='inputStyle'
                                type='text'
                                name='user'
                                placeholder='Username'
                                value={user}
                                onChange={(e)=>setUser(e.target.value)}
                                required
                            />
                        </div>
                        <div className='inputField'>
                            <input
                                className='inputStyle'
                                type={showPass?'text':'password'}
                                name='pass'
                                placeholder='Password'
                                value={pass}
                                onChange={(e)=>setPass(e.target.value)}
                                required
                            />
                        </div>
                        <div className='inputField checkboxLogin'>
                            <input
                                type='checkbox'
                                value={showPass}
                                onChange={(e)=>setShowPass(!showPass)}
                            />
                            <label>Show Password</label>
                        </div>
                        <div className=' submitLogin'>
                            <input
                                className='btn btnSubmit mainBtn'
                                type='submit'
                                value="Log in"
                            />
                        </div>
                    </form>
                    <h4 className='passwordForgot' onClick={()=>setForget(!forget)}>Forgot Password</h4>
                </div>
            </div>
            {forget?forgetPass():null}
        </div>
    )
}